import { Notify } from 'quasar'

export default async ({ Vue }) => {
  Vue.prototype.notify$ = ({ message }) => {
    Notify.create({
      message,
      position: 'bottom-right'
    })
  }
}
